const xpBalanceMemoryCache = {
	key: null,
	value: null,
	promise: null
};

export default class XpBalance {
	constructor(options = {}) {
		this.catalogConf = options.catalogConf || (window.globalConf ? window.globalConf(window.globalCatalogConf) : null);
	}

	getToken() {
		const loyaltyConf = window.globalConf && window.globalLoyaltyConf
			? window.globalConf(window.globalLoyaltyConf)
			: null;

		if (loyaltyConf && loyaltyConf.customer && loyaltyConf.customer.token) {
			return `Bearer ${loyaltyConf.customer.token}`;
		}

		if (this.catalogConf && this.catalogConf.customer && this.catalogConf.customer.token) {
			return `Bearer ${this.catalogConf.customer.token}`;
		}

		return '';
	}

	getCacheKey() {
		const balanceUrl = this.catalogConf && this.catalogConf.bonuses
			? this.catalogConf.bonuses.urlBalance
			: '';
		const customerId = this.catalogConf && this.catalogConf.customer
			? this.catalogConf.customer.id
			: '';

		return `${balanceUrl}::${customerId}`;
	}

	formatBalance(rawBalance) {
		if (typeof rawBalance === 'undefined' || rawBalance === null) return '0';

		const parsed = parseFloat(String(rawBalance));
		if (Number.isNaN(parsed)) return '0';

		return parsed.toFixed(2);
	}

	async fetchBalanceFromApi() {
		const token = this.getToken();
		const response = await fetch(this.catalogConf.bonuses.urlBalance, {
			method: 'POST',
			headers: {
				'Authorization': token
			},
			body: JSON.stringify({
				id: this.catalogConf.customer.id
			})
		});

		const data = await response.json();

		if (!data || data.code !== 200 || !data.data) {
			throw new Error('Invalid balance response');
		}

		return this.formatBalance(data.data.balance);
	}

	async getBalance(options = {}) {
		const force = !!options.force;

		if (!this.catalogConf || !this.catalogConf.bonuses || !this.catalogConf.bonuses.urlBalance) {
			return null;
		}

		const cacheKey = this.getCacheKey();

		if (!force && xpBalanceMemoryCache.key === cacheKey && xpBalanceMemoryCache.value !== null) {
			return xpBalanceMemoryCache.value;
		}

		if (!force && xpBalanceMemoryCache.key === cacheKey && xpBalanceMemoryCache.promise) {
			return xpBalanceMemoryCache.promise;
		}

		xpBalanceMemoryCache.key = cacheKey;
		xpBalanceMemoryCache.promise = this.fetchBalanceFromApi();

		try {
			const balance = await xpBalanceMemoryCache.promise;
			xpBalanceMemoryCache.value = balance;
			return balance;
		} catch (e) {
			xpBalanceMemoryCache.value = null;
			console.error('Error getting balance:', e);
			return null;
		} finally {
			xpBalanceMemoryCache.promise = null;
		}
	}

	clearCache() {
		xpBalanceMemoryCache.key = null;
		xpBalanceMemoryCache.value = null;
		xpBalanceMemoryCache.promise = null;
	}
}